import { createMixpanelAnalyticsClient } from '@satellite/analytics/createMixpanelAnalyticsClient';
import type { AnalyticsClient } from '@satellite/composables/useAnalytics';
import config from '@/config/config';

/**
 * Builds the Mixpanel client Luna provides through `analyticsKey`.
 *
 * No `sessionReplay` config is passed: Luna records the registration funnel by hand through
 * the client's lifecycle methods (see useLunaSessionRecording) rather than sampling whole
 * sessions, which is also what the legacy plugin did.
 */
export function createLunaAnalyticsClient(): AnalyticsClient {
  return createMixpanelAnalyticsClient({
    token: config.mixpanel_token,
    serverEnv: config.server_env
  });
}
